import { DotcAsset } from '@swarm/types/tokens/dotc'
import { XOfferFilter } from '@swarm/types/x-subgraph/graphql'

import { isErc1155 } from '@core/shared/utils/tokens/filters'
import { unifyAddressToId } from '@core/web3/utils'

const getDepositAssetFilter = (token?: DotcAsset) =>
  token &&
  (isErc1155(token.type)
    ? {
        depositAsset_: { address: token.address },
      }
    : {
        depositAsset: unifyAddressToId(token.id),
      })

const getWithdrawalAssetFilter = (token?: DotcAsset) =>
  token &&
  (isErc1155(token.type)
    ? {
        withdrawalAsset_: { address: token.address },
      }
    : {
        withdrawalAsset: unifyAddressToId(token.id),
      })

export const getAssetFilter = (
  tokenIn?: DotcAsset,
  tokenOut?: DotcAsset,
): XOfferFilter => {
  const depositAssetFilter = getDepositAssetFilter(tokenIn)

  const withdrawalAssetFilter = getWithdrawalAssetFilter(tokenOut)

  return { ...depositAssetFilter, ...withdrawalAssetFilter }
}
